var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Menu, MenuButton, MenuList, MenuItem, Button, useMediaQuery, } from "@chakra-ui/react";
import { TbTool } from "@onemind-services-llc/react-icons-ng/tb";
import { FaCog } from "@onemind-services-llc/react-icons-ng/fa";
import { RiArrowDownSFill } from "@onemind-services-llc/react-icons-ng/ri";
/** This component will display popover with menulist */
export const ActionMenu = (props) => {
    const [isMobileOrTablet] = useMediaQuery("(max-width: 1080px)");
    const defaultIcon = isMobileOrTablet ? _jsx(FaCog, {}) : _jsx(TbTool, {});
    const { menuList, menuIcon = defaultIcon, showRightIcon = true, id } = props, rest = __rest(props, ["menuList", "menuIcon", "showRightIcon", "id"]);
    return (_jsx(Box, { onClick: (e) => e.stopPropagation(), children: _jsxs(Menu, Object.assign({ id: id }, rest, { children: [isMobileOrTablet ? (_jsx(MenuButton, { "data-cy": "selectList", children: menuIcon })) : (_jsx(MenuButton, { "data-cy": "selectList", as: showRightIcon ? Button : undefined, rightIcon: showRightIcon ? _jsx(RiArrowDownSFill, {}) : undefined, children: menuIcon })), _jsx(MenuList, { children: menuList === null || menuList === void 0 ? void 0 : menuList.map((menuItem, index) => {
                        const { label } = menuItem, rest = __rest(menuItem, ["label"]);
                        return (_jsx(MenuItem, Object.assign({}, rest, { children: label }), index));
                    }) })] })) }));
};
//# sourceMappingURL=actionMenu.js.map